// Template: User blocked the campaign owner from sending affiliate proposals notification
export const AffiliateProposalBlock = `
<div>

  <div style="display: flex; align-items: center; gap: 12px; background: linear-gradient(135deg, #1a202c, #2d3748); border-radius: 8px; padding: 12px 16px; margin-bottom: 20px;">
    <span style="font-size: 1.4rem; flex-shrink: 0;">🚫</span>
    <div>
      <div style="font-size: 0.95rem; font-weight: 700; color: #fff;">Solicitação bloqueada</div>
      <div style="font-size: 0.82rem; color: rgba(255,255,255,0.5); margin-top: 2px;">Você não pode mais enviar solicitações de afiliação para esta campanha.</div>
    </div>
  </div>

  <p style="font-size: 0.95rem; color: #4a5568; line-height: 1.9; margin-bottom: 20px;">
    O usuário
    <a href="{{ownerProfileUrl}}" style="font-weight: 700; text-decoration: none; color: #6c63ff;">{{ownerName}}</a>
    <a href="{{ownerProfileUrl}}" style="background: linear-gradient(135deg, #6c63ff, #a855f7); color: #fff; font-weight: 600; font-size: 0.75rem; border-radius: 6px; padding: 3px 8px;">@{{ownerAtSign}}</a>
    bloqueou suas solicitações de afiliação para a campanha
    <a href="{{campaignPageUrl}}" style="font-weight: 700; text-decoration: none; color: #6c63ff;">{{campaignName}}</a>
    <a href="{{campaignPageUrl}}" style="background: #f0f4ff; color: #6c63ff; border: 1px solid #c7d2fe; font-weight: 600; font-size: 0.75rem; border-radius: 6px; padding: 3px 8px;">#{{campaignKey}}</a>.
  </p>

  <div style="display: flex; gap: 12px; margin-bottom: 20px;">
    <div style="flex: 1; background: #f8faff; border: 1px solid #e0e7ff; border-radius: 10px; padding: 12px 16px;">
      <div style="font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #a0aec0; margin-bottom: 4px;">Campanha</div>
      <div style="font-size: 0.95rem; font-weight: 700; color: #2d3748;">{{campaignName}}</div>
    </div>
    <div style="flex: 1; background: #f8faff; border: 1px solid #e0e7ff; border-radius: 10px; padding: 12px 16px;">
      <div style="font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #a0aec0; margin-bottom: 4px;">Data do bloqueio</div>
      <div style="font-size: 0.95rem; font-weight: 700; color: #2d3748;">{{createdAt}}</div>
    </div>
  </div>

  <div style="display: flex; gap: 8px; background: #fff5f5; border: 1px solid #feb2b2; border-left: 3px solid #e53e3e; border-radius: 8px; padding: 12px 16px; margin-bottom: 20px;">
    <span style="font-size: 1rem; line-height: 1.65;">🚨</span>
    <span style="font-size: 0.85rem; color: #742a2a;">
      Você não poderá enviar novas solicitações de afiliação para esta campanha.
    </span>
  </div>

  <div style="display: flex; gap: 8px; background: #fffbeb; border: 1px solid #fde68a; border-left: 3px solid #f6ad55; border-radius: 8px; padding: 12px 16px; margin-bottom: 20px;">
    <span>💡</span>
    <span style="font-size: 0.85rem; color: #92400e; line-height: 1.65;">
      O bloqueio é válido apenas para esta campanha <strong>{{campaignName}}</strong>. Você ainda pode se afiliar a outras campanhas do mesmo proprietário e outras disponíveis na plataforma.
    </span>
  </div>

  <a href="{{campaignAffiliatePageUrl}}" style="display: block; width: 100%; background: #f8faff; color: #6c63ff; border: 1px solid #c7d2fe; border-radius: 8px; font-weight: 600; font-size: 0.88rem; padding: 10px 0; cursor: pointer; text-align: center; text-decoration: none;">
    Informações de Afiliação
  </a>

</div>
`;
